// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* * * * * * * * * * * * * * *\n\t\tdisplay sizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tsizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tcolors\n* * * * * * * * * * * * * * */\n/* fonts */\n/* borders */\n/* rest */\n/* new colors */\n.rule-title__Packages_1o8Py {\n  padding-top: 10px;\n  margin-bottom: 10px;\n  border-top: 1px solid;\n  border-image: linear-gradient(90deg, rgba(128, 128, 128, 0.1), rgba(0, 0, 0, 0.6), rgba(128, 128, 128, 0.1)) 1;\n}\n.rule-title__Packages_1o8Py:first-of-type {\n  border-top: 0;\n}\n.buttons__Packages_298CE {\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
exports.locals = {
	"rule-title": "rule-title__Packages_1o8Py",
	"ruleTitle": "rule-title__Packages_1o8Py",
	"buttons": "buttons__Packages_298CE"
};
module.exports = exports;
